import * as React from "react"

export const BREAKPOINTS = {
  MOBILE: 768,
  LAPTOP: 1366,
} as const

type BreakpointType = keyof typeof BREAKPOINTS

export function useBreakpoint(breakpoint: BreakpointType) {
  const [isBelow, setIsBelow] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const checkBreakpoint = () => {
      setIsBelow(window.innerWidth < BREAKPOINTS[breakpoint])
    }

    const mql = window.matchMedia(
      `(max-width: ${BREAKPOINTS[breakpoint] - 1}px)`
    )
    mql.addEventListener("change", checkBreakpoint)

    checkBreakpoint()

    return () => mql.removeEventListener("change", checkBreakpoint)
  }, [breakpoint])

  return !!isBelow
}

export function useIsMobile() {
  return useBreakpoint("MOBILE")
}

export function useIsLaptop() {
  return useBreakpoint("LAPTOP")
}
